import { render, staticRenderFns } from "./OperaCreationWindow.vue?vue&type=template&id=c2e89788&scoped=true&"
import script from "./OperaCreationWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCreationWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaCreationWindow.vue?vue&type=style&index=0&id=c2e89788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e89788",
  null
  
)

export default component.exports